module.exports = __webpack_public_path__ + "img/skinxs-logo-large.a4405b5e.svg";